import Vue from 'vue';
import 'moment';
import '@mdi/font/css/materialdesignicons.css';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import '@/plugins/comm';
import store from './store';
import vuetify from './plugins/vuetify';

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
